export default {
  'channelOnboarding.back': 'Volver',
  'channelOnboarding.description': 'Alta unificada de actores comerciales en una sola transacción.',

  'channelOnboarding.fields.entityType': 'Tipo de registro',
  'channelOnboarding.fields.automyPlan': 'Plan AUTOMY',
  'channelOnboarding.fields.identity': 'Identidad fiscal / ID',
  'channelOnboarding.sections.companyData': 'Datos de la empresa',
  'channelOnboarding.sections.ownerUser': 'Administrador principal',
  'channelOnboarding.fields.ownerUser.lastNames': 'Apellidos',
  'channelOnboarding.fields.ownerUser.invitationHint':
    'Se enviará una invitación de activación al correo indicado.',

  'channelOnboarding.steps.entityType.title': 'Tipo de registro',
  'channelOnboarding.steps.entityType.hint':
    'Elija el tipo de actor. Los campos y validaciones cambian según su selección.',
  'channelOnboarding.steps.plan.title': 'Plan AUTOMY',
  'channelOnboarding.steps.plan.hint':
    'Seleccione un plan activo para la empresa que se creará. La suscripción de facturación se genera automáticamente.',
  'channelOnboarding.steps.company.title': 'Empresa',
  'channelOnboarding.steps.actor.title': 'Actor de canal',
  'channelOnboarding.steps.agreement.title': 'Acuerdo comercial',
  'channelOnboarding.steps.agreement.hint':
    'Solo se listan acuerdos aprobados. Puede asignar uno ahora o dejarlo vacío y asignarlo después.',
  'channelOnboarding.steps.billing.title': 'Facturación',
  'channelOnboarding.steps.billing.hint':
    'Datos fiscales y de contacto opcionales para la suscripción de facturación.',
  'channelOnboarding.steps.summary.title': 'Resumen',

  'channelOnboarding.fields.canCreateDistributors': 'Puede crear distribuidores',

  'channelOnboarding.actions.confirmRegister': 'Confirmar registro',
  'channelOnboarding.actions.registerAnother': 'Registrar otro actor',

  'channelOnboarding.registrationSummary.title': 'Registro completado',
  'channelOnboarding.registrationSummary.subtitle':
    'La empresa se creó correctamente. Revise el resumen consolidado del registro.',
  'channelOnboarding.registrationSummary.loadError':
    'No se pudo cargar el resumen del registro. Intente nuevamente.',
  'channelOnboarding.registrationSummary.sections.company': 'Empresa',
  'channelOnboarding.registrationSummary.sections.channelProfile': 'Perfil comercial',
  'channelOnboarding.registrationSummary.sections.channelEntity': 'Actor de canal',
  'channelOnboarding.registrationSummary.sections.billingSubscription':
    'Suscripción de facturación',
  'channelOnboarding.registrationSummary.sections.aiBillingProfile': 'Facturación de IA',
  'channelOnboarding.registrationSummary.sections.defaultEnvironment': 'Entorno por defecto',
  'channelOnboarding.registrationSummary.fields.agreementId': 'Acuerdo comercial',
  'channelOnboarding.registrationSummary.fields.budgetEnabled': 'Presupuesto habilitado',
  'channelOnboarding.registrationSummary.fields.environmentType': 'Tipo de entorno',
  'channelOnboarding.registrationSummary.fields.isDefault': 'Por defecto',
  'channelOnboarding.registrationSummary.fields.isPublic': 'Público',

  'channelOnboarding.progress.title': 'Progreso del registro',
  'channelOnboarding.step.inProgress': 'En curso',

  'channelOnboarding.errors.selectEntityTypeFirst': 'Seleccione primero un tipo de registro.',
  'channelOnboarding.errors.duplicateIdentity': 'Esta identidad ya está en uso.',
  'channelOnboarding.errors.planNotAllowedForActor':
    'El plan seleccionado no está permitido para este tipo de actor.',
};
